/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  SimpleChanges,
  OnChanges,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { DataTableHeader } from '../../../../data-table/DataTableHeader';
import { FRAUDTYPE_MAPPINGS, SELLER_FRAUD_TYPES } from '../CTV_DETAILS_CONFIG';
import { User } from '../../../../../models/User';
import { CustomItemContext } from 'app/components/data-table/data-table.component';

declare let jQuery;
@Component({
  selector: 'app-ctv-authorized-seller',
  templateUrl: './ctv-authorized-seller.component.html',
  styleUrls: ['./ctv-authorized-seller.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvAuthorizedSellerComponent
  implements OnInit, AfterViewInit, OnChanges
{
  headers: Array<DataTableHeader>;
  subHeaders: Array<DataTableHeader>;
  @Input() data: any;
  @Input() includeAppSpoofing: boolean;
  @Input() isFollowing: boolean;
  @Input() isFreemium: boolean;
  @Output() followClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('sellerNameTemplate')
  sellerNameTemplate: TemplateRef<CustomItemContext>;

  sellerMap = [];
  colorMapping: any;
  tooltipMapping = {
    Direct:
      'The contribution of direct sellers to programmatic ad impressions sold on the app.',
    Reseller:
      'The contribution of resellers (e.g., intermediaries, etc.) to programmatic ad impressions sold on the app.',
    'N/A':
      'The contribution of unauthorized sellers (based on exclusion from App-Ads.Txt file) to programmatic ad impressions sold on the app.'
  };
  fraudTypeMappings = FRAUDTYPE_MAPPINGS;
  subDataTables = [];

  constructor(private userService: User) {}

  ngAfterViewInit(): void {
    this.initData();
  }

  ngOnInit(): void {
    this.headers = [];
    this.headers.push({
      class: 'col-2',
      text: 'SSP/EXCHANGE',
      key: 'sellerName',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col-2 text-xs-right',
      text: 'PROGRAMMATIC AVAILS',
      key: 'totalInventoryRatio',
      tooltipkey: '',
      format: 'percent',
      lockedInFreemium: this.isFreemium
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: 'EST. IVT %',
      key: 'givtSivtRate',
      tooltipkey: '',
      format: 'percent',
      lockedInFreemium: this.isFreemium
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: 'DISPLAY',
      key: 'displayImpressionsRatio',
      tooltipkey: '',
      format: 'percent'
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: 'VIDEO SOV',
      key: 'videoImpressionsRatio',
      tooltipkey: '',
      format: 'percent'
    });

    const isCollapse = this.includeAppSpoofing ? 'true' : 'false';
    this.headers.push({
      class: 'col text-xs-right',
      text: 'SPOOFING',
      key: 'appSpoofingRate',
      tooltipkey: '',
      format: 'percent',
      isCollapse: isCollapse,
      lockedInFreemium: this.isFreemium
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: 'EST. SSAI',
      key: 'nonGivtSivtSsaiImpressionsRate',
      tooltipkey: '',
      format: 'percent'
    });
    this.headers.push({
      class: 'col-2 text-xs-right',
      text: 'EST. TRANSPARENT SSAI',
      key: 'nonGivtSivtSsaiTransparentImpressionsRate',
      tooltipkey: '',
      format: 'percent'
    });

    this.subHeaders = [];
    this.subHeaders.push({
      class: 'col-2',
      text: 'Declared Bundle ID',
      key: 'declaredBundleId',
      tooltipkey: ''
    });
    this.subHeaders.push({
      class: 'col-3 text-xs-right',
      text: 'DETECTED BUNDLE ID',
      key: 'detectedBundleId',
      tooltipkey: ''
    });
    this.subHeaders.push({
      class: 'col text-xs-right',
      text: 'SOV',
      key: 'totalTrafficRatio',
      tooltipkey: '',
      format: 'percent'
    });
    this.subHeaders.push({
      class: 'col text-xs-right',
      text: 'EST. SSAI',
      key: 'nonGivtSivtSsaiImpressionsRate',
      tooltipkey: '',
      format: 'percent'
    });

    this.colorMapping = {};
    this.colorMapping['N/A'] = [
      '#DB1F26',
      '#E04B33',
      '#E66C46',
      '#EC875D',
      '#F3A375',
      '#fbe0d0'
    ];
    this.colorMapping['Direct'] = [
      '#2652B2',
      '#3567D4',
      '#5F87DD',
      '#89A6E6',
      '#B3C6EF',
      '#eaeffb'
    ];
    this.colorMapping['Reseller'] = [
      '#2652B2',
      '#3567D4',
      '#5F87DD',
      '#89A6E6',
      '#B3C6EF',
      '#eaeffb'
    ];
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initData();
  }

  follow(): void {
    this.followClick.emit(true);
  }

  initData() {
    this.sellerMap = JSON.parse(JSON.stringify(SELLER_FRAUD_TYPES));
    this.data.sellerDistribution.sellers.forEach(seller => {
      const paymentType = seller.paymentType;
      const foundSellerMap = this.sellerMap.find(
        fs => fs.paymentType === paymentType
      );
      seller['sellerNameTemplate'] = this.sellerNameTemplate;

      if (!foundSellerMap) {
        this.sellerMap.push({
          paymentType: paymentType,
          sellers: [seller],
          chartData: [
            {
              category: seller?.sellerName,
              value: seller?.totalInventoryRatio,
              title: seller?.sellerName
            }
          ]
        });
      } else {
        // if (foundSellerMap[0].sellers.length < 5) {
        foundSellerMap.sellers.push(seller);
        foundSellerMap.chartData.push({
          category: seller?.sellerName,
          value: seller?.totalInventoryRatio,
          title: seller?.sellerName
        });
        // }
      }
    });
    this.initCollapse();
  }

  initCollapse() {
    setTimeout(() => {
      jQuery('[data-toggle="collapse"]').collapse();
    }, 100);

    setTimeout(() => {
      jQuery('[data-toggle="collapse"]').attr('aria-expanded', 'false');
    }, 200);
  }

  generateSubTables(seller: any) {
    const subDataTables = [];
    seller['subDataTables'] = subDataTables;
    seller['appsByFraudType'].forEach(byFraudType => {
      const fraudType = byFraudType.fraudType;
      let foundTable = subDataTables.filter(table => table.key === fraudType);
      if (!foundTable || !foundTable[0]) {
        const textMapping = this.fraudTypeMappings[fraudType];
        foundTable = [
          {
            key: fraudType,
            text: textMapping ? textMapping : fraudType,
            addClass: byFraudType.skipDetectedBundleId
              ? 'skipDetectedBundleId'
              : '',
            data: []
          }
        ];
        subDataTables.push(foundTable[0]);
      }
      if (foundTable && foundTable[0]) {
        foundTable[0].percentValue = byFraudType.totalTrafficRatio;
        foundTable[0].data = byFraudType.apps;
      }
    });
  }
}
